(function() {
    'use strict';

    angular.module('app.aeronaves', []);
})();
